import { activityLogApiSlice } from './slices';

export const adminSlices = {
  [activityLogApiSlice.reducerPath]: activityLogApiSlice.reducer,
};

export { useGetActivityLogQuery } from './slices';
